import React from "react";
import "./ConfirmLogoutPopup.css";

const ConfirmLogoutPopup = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-logout-overlay" onClick={onCancel}>
      <div
        className="confirm-logout-popup"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="confirm-logout-content">
          <h3>Confirm Logout</h3>
          <p>Are you sure you want to logout?</p>
          <div className="confirm-logout-buttons">
            <button className="confirm-btn" onClick={onConfirm}>
              Logout
            </button>
            <button className="cancel-btn" onClick={onCancel}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmLogoutPopup;
